import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface MobileRowContentProps<T> {
  data: T;
  mainContent: (data: T) => React.ReactNode;
  expandableContent?: (data: T) => React.ReactNode;
  hasExpandableContent?: boolean;
}

const MobileRowContent = <T extends { Id: number }>({
  data,
  mainContent,
  expandableContent,
  hasExpandableContent = true,
}: MobileRowContentProps<T>) => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
          flex: 1,
        }}
      >
        {mainContent(data)}
      </Box>
      {hasExpandableContent && expandableContent && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            padding: '0.5rem 0',
          }}
        >
          {expandableContent(data)}
        </Box>
      )}
    </>
  );
};

export default MobileRowContent;
